/**
 * The two messages between the main app and an agent's app shown in its pane.
 *
 * The source of truth is @ai4nr/tricorder-ui `shell/embed.ts`, the side every
 * embedded app runs. This is its mirror for the host side until the main app
 * consumes that package (care-app has no GitHub Packages install yet); a change
 * there is made here in the same week, field for field.
 */
export const EMBED_PARAM = 'embed'
export const EMBED_MESSAGE_SOURCE = 'tricorder-embed'

export type EmbedMessage =
  | { source: typeof EMBED_MESSAGE_SOURCE; type: 'signed-out' }
  | { source: typeof EMBED_MESSAGE_SOURCE; type: 'navigated'; path: string }

export function isEmbedMessage(data: unknown): data is EmbedMessage {
  if (typeof data !== 'object' || data === null) return false
  const m = data as Record<string, unknown>
  if (m.source !== EMBED_MESSAGE_SOURCE) return false
  return m.type === 'signed-out' || (m.type === 'navigated' && typeof m.path === 'string')
}
